module.exports = __webpack_public_path__ + "img/biologics.fecbbee8.png";